import {Component, Element, Fragment, h, Host, Listen, Method, Prop, State} from "@stencil/core";
import {WebUtils} from "../../core/utils/WebUtils";
import {StringUtils} from "../../core/utils/StringUtils";
import {CookieUtils} from "../../core/utils/CookieUtils";
import focusTrap from "focus-trap";
import {FocusTrap} from "focus-trap";
import { ComponentConstants } from "../ComponentConstants";

@Component({
    tag: 'snt-header',
    styleUrl: "header-component.scss",
    shadow: false
})
export class HeaderComponent {

    public static readonly TAG_NAME = "snt-header";

    @Element() element!: HTMLElement;

    private static readonly SECONDARY_NAV_MOBILE_SLOT_NAME = "secondary-nav-mobile";

    @Prop({reflect: true}) styleClasses:string = StringUtils.empty();
    @Prop({reflect: true}) fixed:boolean = false;
    @Prop({reflect: true}) languageJson:string = StringUtils.empty();
    @Prop({reflect: true}) mainContentId:string = StringUtils.empty();
    @Prop({reflect: true}) active:boolean = false;
    @Prop() languageUrl:string = '/fr';
    @Prop() languageToggleText:string = 'Fr';
    @Prop() navData:string;
    @Prop() buttonIds:string;
    @Prop() logoAlt:string;
    @Prop() logoUrl:string;

    @State() shrunk:boolean = false;
    @State() scrollAtTop:boolean = true;

    private languageStrings:object = {};
    private buttonIdsJson:object = {};
    private focusTrap:FocusTrap = null;
    private gaqButtonActionData = null;
    private searchBar:HTMLSntSearchBarElement;
    private tabletSearchBar:HTMLSntSearchBarElement;
 
    private navDefaultHeight:number = 64;
    private navCurrentHeight:number = 64;
    private navWithSearchHeight:number = 100;

    private isSearchOpen:boolean = false;
    private isTabletTabOpen:boolean = false;
    private navDataMap = {
        0: {data: [], title: ''},
        1: {data: [], title: ''},
        2: {data: [], title: ''},
        3: {data: [], title: ''},
    }

    private cartValue: string = "0";

    private toggleTabletTab = () => {
        const navEl = this.element.querySelector('snt-navbar');
        navEl.style.height = 'auto';
        navEl.classList.toggle('nav-expanded');

        const container = this.element.querySelector('#tablet-items-container');
        container.classList.toggle('show');

        const tabletTopQuoteWrapper = this.element.querySelector('#tablet-top-quote-wrapper');
        if (tabletTopQuoteWrapper) {
            tabletTopQuoteWrapper.classList.toggle('show');
        }
        this.isTabletTabOpen = !this.isTabletTabOpen;

        //hamburger animation
        const hamburgerSqueeze = navEl.querySelector('.hamburger--squeeze');
        hamburgerSqueeze.classList.toggle('is-active');

        // disable scroll on body
        const body = document.querySelector<HTMLElement>('html > body');
        // const mainContent = document.querySelector<HTMLElement>('html > body > #main-content');
        if (body && body.style && body.style.overflow && body.style.overflow === 'hidden') {
            body.style.overflow = 'scroll';
            // mainContent.style.overflow = 'scroll'; 
        } else {
            body.style.overflow = 'hidden';
            // mainContent.style.overflow = 'hidden'; // This breaks the sticky for promo banner
        }
    }

    private showTabletItems = (tabId) => {
        const el = this.element.querySelector(`#tablet-tab-${tabId}-items`)
        el.classList.toggle('tablet-tab-items-show');

        const tabletTab = this.element.querySelector(`#tablet-tab-${tabId}`)
        tabletTab.classList.toggle('tablet-tab-show');
        tabletTab.classList.toggle('tablet-border-bottom');

        // chevron
        const chevron = el.previousElementSibling.querySelector('.chevron')
        if (chevron) {
            chevron.classList.toggle('top');
            chevron.classList.toggle('bottom');
        }
    }

    private resetHoverEffectOnNavItems() {
        Object.keys(this.navDataMap).forEach((key)=>{
            if (this.element.querySelector(`snt-nav-item[tab-idx="${key}"] snt-link a`).classList.contains('snt-link-hover-effect')) {
                this.element.querySelector(`snt-nav-item[tab-idx="${key}"] snt-link a`).classList.remove('snt-link-hover-effect');
            }
        });
    }

    private handleOpenSlab = (evt) => {
        this.element.querySelector('.dropdown-slab').classList.remove('show');
        this.element.querySelector('snt-navbar').classList.add('nav-expanded');

        const id = evt.detail + 1;
        const tag = `#slab-${id}`
        this.element.querySelector(tag).classList.add('show');
        const height = parseInt(this.element.querySelector<HTMLElement>(`${tag} .dropdown-container`).style.height)
        this.navCurrentHeight = height + 64;

        this.element.querySelector('snt-navbar').style.height = `${this.navCurrentHeight}px`;
        this.searchBar.toggleActive('close');

        // remove (if any) current hover effect on nav items and keep hover effect opened nav item
        this.resetHoverEffectOnNavItems();
        this.element.querySelector(`snt-nav-item[tab-idx="${evt.detail}"] snt-link a`).classList.add('snt-link-hover-effect');
    }

    private handleCloseSlab = () => {
        this.element.querySelectorAll('.dropdown-slab').forEach(e => e.classList.remove('show'));
        this.element.querySelector('snt-navbar').classList.remove('nav-expanded');
        const height = this.isSearchOpen ? this.navWithSearchHeight + 'vh' : this.navDefaultHeight + 'px';
        if (!this.isSearchOpen) {
            this.element.querySelector('snt-navbar').style.height = `${height}`;
        }
        this.resetHoverEffectOnNavItems();
    }

    @Listen('toggleSearch')
    onToggleSearch() {
        this.handleCloseSlab();
        this.searchBar.toggleActive().then((active) => {
            this.toggleFocusTrap(active);
            this.isSearchOpen = active;
        })
    }

    @Listen('toggleTabletSearch')
    onToggleTabletSearch() {
        const navEl = this.element.querySelector('snt-navbar');
        navEl.classList.toggle('hide');
        if(!navEl.classList.contains('hide')) navEl.style.height = 'auto';
        this.tabletSearchBar.toggleActive();

    }

    @Listen('searchBarToggled')
    searchBarToggleHandler(evt) {
        const isOpen = evt.detail;
        const navEl = this.element.querySelector('snt-navbar');
        if (isOpen) {
            const height = '125px';
            navEl.classList.add('nav-expanded');
            navEl.style.height = height;
        } else {
            navEl.style.height = this.navDefaultHeight + 'px';
            navEl.classList.remove('nav-expanded');
        }

        // this.isSearchOpen = isOpen;
    }

    @Listen('navHeaderHover')
    navHoverHandler(evt:CustomEvent) {
        this.handleOpenSlab(evt);
    }

    @Listen('scroll', { target: 'window' })
    handleScroll() {
      this.scrollAtTop = window.scrollY <= 150;
    }

    @Listen('mouseleave')
    handleMouseLeaveNav() {
        // close slab if still open
        this.handleCloseSlab();
        // close search if still open
        this.isSearchOpen = false;
    }

    // For tab enter on top menu
    @Listen('newLinkEvent')
    handleLinkExpandToggle(evt:CustomEvent) {
        this.handleOpenSlab(evt);
        const id = parseInt(evt.detail) + 1
        // close other slabs
        this.closeOtherSlabs(id)
        // focus on first thing in slab
        
        const slabEl = this.element.querySelector(`#slab-${id}`);
        const firstItem = slabEl.getElementsByClassName('dropdown-item-container')[0];
        (firstItem as HTMLElement)?.focus();
        
    }

    @Method()
    async toggleActive(active?:boolean):Promise<boolean> {
        this.active = (typeof(active) === "boolean") ? active : !this.active;
        this.toggleFocusTrap(this.active);
        return Promise.resolve(this.active);
    }

    @Method()
    async setActive(active: boolean):Promise<boolean> {
        this.active = active;
        this.toggleFocusTrap(this.active);
        return Promise.resolve(this.active);
    }

    componentWillLoad() {
        // parse tabs data
        const data = JSON.parse(this.navData);
        for (const [k, v] of Object.entries(data)) {
            this.navDataMap[v["order"]]["data"] = [...v["subItems"]];
            this.navDataMap[v["order"]]["title"] = k; 
        }
        try {
            this.languageStrings = JSON.parse(this.languageJson);
            this.buttonIdsJson = JSON.parse(this.buttonIds);
        } catch(e) {
            console.error(e)
        };
        this.gaqButtonActionData = JSON.stringify({
            getAQuoteUrl: this.languageStrings["getAQuoteUrl"],
            languageString: {
                close : this.languageStrings["close"]
            }
        });
    }

    componentDidLoad() {
        this.focusTrap = focusTrap(this.element, {});
        this.searchBar = this.element.querySelector('#desktop-search-bar');
        this.tabletSearchBar = this.element.querySelector('#tablet-search-bar')
        this.cartValue = CookieUtils.readCookie(ComponentConstants.CART_COOKIE_NAME);
        this.showTabletItems(1);
        this.showTabletItems(2);
    }

    componentDidRender() {
        const menuItems = this.element.querySelectorAll('#main-nav snt-nav-item.noclick-nav.top-nav .nav-link');
        menuItems.forEach((x, ind) => {
            x.addEventListener("mouseenter", () => {
                this.closeOtherSlabs(ind+1);
                this.isSearchOpen = false;
            });
        });
    }

    private toggleFocusTrap(active: boolean) {
        active ? this.focusTrap.activate() : this.focusTrap.deactivate();
    }

    private redirectTo(url) {
        window.location.href = url
    }

    private closeOtherSlabs(curSlab) {
        const id = `slab-${curSlab}`
        Array.from(this.element.getElementsByClassName('dropdown-slab show')).forEach(el => {
            (el.id !== id) && el.classList.remove("show");
        })
    }

    private generateSlab(id) {
        const data = this.navDataMap[id - 1].data;
        const height = (Math.ceil(data.length / 2) * 82) + 41;
        const leftTabletCol = data.filter((_, ind) => ind % 2 === 0);
        const rightTabletCol = data.filter((_, ind) => ind % 2 !== 0);

        return (                                    
            <div class="dropdown-slab" id={`slab-${id}`}>
                <div class="dropdown-container" style={{"height": `${height}px`}}>
                    <div class="tablet-column">
                        {this.generateTabletColumns(leftTabletCol)}
                    </div>
                    <div class="tablet-column">
                        {this.generateTabletColumns(rightTabletCol)}
                    </div>
                </div>
            </div>
        )
    }

    private generateTabletColumns(arr) {
        const newText = this.languageStrings["new"] || "New!";
        return arr.map(l => {
            return (
                <div class="dropdown-item-container" onClick={() => {this.redirectTo(l.url)}} tabindex={0} onKeyDown={(e)=>{e.key === "Enter" && this.redirectTo(l.url)}} id={l.buttonId}>
                    <snt-nav-item>
                        <snt-link href={l.url} class="dropdown-maintext" disableFocus={true} linkId={l.buttonId}>{l.header}</snt-link>
                        { l.isNew && <span class="new-tag">{newText}</span> }
                        <div class="dropdown-subtext">{l.subtext}</div>
                    </snt-nav-item>
                </div>
            );
        });
    }

    private updateTabIndex() {
        const visibleTabletItemsContainers = this.element.querySelectorAll('.tablet-tab-items-container.tablet-tab-items-show');
        visibleTabletItemsContainers.forEach(tabletItemsContainer => {
            const visibleItemContainers = tabletItemsContainer.querySelectorAll('.dropdown-item-container');
            visibleItemContainers.forEach(dropdownItemContainer => {
                dropdownItemContainer.setAttribute('tabindex', '0');
            });
        });

        const collapsedTabletItemsContainers = this.element.querySelectorAll('.tablet-tab-items-container:not(.tablet-tab-items-show)');
        collapsedTabletItemsContainers.forEach(tabletItemsContainer => {
            const visibleItemContainers = tabletItemsContainer.querySelectorAll('.dropdown-item-container');
            visibleItemContainers.forEach(dropdownItemContainer => {
                dropdownItemContainer.setAttribute('tabindex', '-1');
            });
        });
    }

    private generateTabTitle(tabletTabID, title) {
        if (tabletTabID === 1 || tabletTabID === 2 ) {
            return (
                <div>{title}</div>
            )
        }
        return (
            <div>{title} <span class="chevron bottom"></span></div>
        )
    }

    private generateTabletItem(id) {
        const dataMap = this.navDataMap[id];
        const leftTabletCol = dataMap.data.filter((_, ind) => ind % 2 === 0);
        const rightTabletCol = dataMap.data.filter((_, ind) => ind % 2 !== 0);
        const mobileCol = dataMap.data.filter(x => !x.excludeInMobile);
        const tabletTabID = id + 1;

        return (
            <Fragment>
                <div
                    id={`tablet-tab-${tabletTabID}`}
                    class={`tablet-item-row tablet-border-bottom`}
                    onClick={()=>this.showTabletItems(tabletTabID)}
                    tabindex={0}
                    onKeyDown={(e)=>{e.key === "Enter" && this.showTabletItems(tabletTabID); this.updateTabIndex();}}
                >
                    { this.generateTabTitle(tabletTabID, dataMap.title) }
                </div>
                <div class="tablet-tab-items-container" id={`tablet-tab-${tabletTabID}-items`}>
                    <div class="tablet-column">
                        {this.generateTabletColumns(leftTabletCol)}
                    </div>
                    <div class="tablet-column">
                        {this.generateTabletColumns(rightTabletCol)}
                    </div>
                    <div class="mobile-column">
                        {this.generateTabletColumns(mobileCol)}
                    </div>
                </div>
            </Fragment>
        )
    }

    private generateDesktopNavAndSlab(slabs) {
        return (
            <snt-nav slot="primary-nav" id="main-nav" expander="keyboard">
                {
                    slabs.map((s, ind) => (
                        <Fragment>
                            <snt-nav-item
                                href="/"
                                target="_self"
                                link-title={this.navDataMap[ind].title}
                                has-expander={true}
                                emit-hover-events={true}
                                tab-idx={ind}
                                isTopNavLink={true}
                                class="noclick-nav top-nav"
                            >
                            </snt-nav-item>
                            {s}
                        </Fragment>
                    ))
                }
                <slot name={HeaderComponent.SECONDARY_NAV_MOBILE_SLOT_NAME}/>
            </snt-nav> 
        );
    }

    private showShoppingCart() {
        if (this.cartValue == undefined || (this.cartValue && parseInt(this.cartValue) === 0)) {
            return false;
        }
        return true;
    }

    render() {
        const slabs = [];
        const tabletItems = [];
        for (let i = 0; i < 4; i++) {
            slabs.push(this.generateSlab(i + 1));
            tabletItems.push(this.generateTabletItem(i));
        }

        return (
            <Host
                onSntBackdropTap={()=>this.setActive(false)}
                onNavbarToggled={()=>this.toggleActive()}
                class={{
                    'shrunk': this.shrunk
                }}
            >
                <div class="header-container">
                    <div>
                        <header class={WebUtils.generateClasses(["header"], this.styleClasses)}>
                            <snt-navbar style-classes="navbar-expand-lg" language-string={this.languageJson}>
                                <div id="bar-items-container">
                                    <snt-skip-to-main main-content-id={`#${this.mainContentId}`}>{this.languageStrings["skipToMainContent"] || "Skip to main content"}</snt-skip-to-main>
                                    <snt-navbar-brand slot="navbar-brand" href={this.languageStrings["logoHref"]} img-alt={this.logoAlt} img-src={this.logoUrl}></snt-navbar-brand>
                                    <snt-navbar-collapse id="navbar-collapse" slot="navbar-collapse" logo-url={this.languageStrings["logoUrl"]}>
                                        <div class="main-panel">
                                            <snt-action-button button-id="get-a-quote-m-header" actionReference="Action.openGetQuoteModal"  linkTitle={this.languageStrings["gaq"] || "Get a Quote"} actionData={this.gaqButtonActionData} styleClasses="gaq-mobile cta theme-default d-flex d-lg-none"/>
                                            {this.generateDesktopNavAndSlab(slabs)}
                                        </div>
                                    </snt-navbar-collapse>
                                    <div id="switch-container">
                                        {
                                            this.scrollAtTop ? 
                                            <snt-nav id="actions-nav" class="actions-nav theme-header-nav" expander="false">
                                                <snt-nav-item id="search-nav-item">
                                                    <snt-action-button action-reference="Action.toggleSearch" icon-class-name="iconNavSearch" link-title="" button-id={this.buttonIdsJson["searchId"]}
                                                    ></snt-action-button>
                                                </snt-nav-item>
                                                <snt-nav-item title="Fr" id="item-with-line" class="nav-item-right-group">
                                                    <snt-link href={this.languageUrl} link-id={this.buttonIdsJson["languageToggleId"]}>{this.languageToggleText}</snt-link>
                                                </snt-nav-item>
                                                <snt-nav-item class="nav-item-right-group">
                                                    <snt-login id="login-slot" language-json={this.languageJson} button-id={this.buttonIdsJson["logInId"]}></snt-login>
                                                </snt-nav-item>
                                                <snt-nav-item class="nav-item-right-group">
                                                    <snt-shopping-cart cartValue={this.cartValue} button-id={this.buttonIdsJson["shoppingCartId"]}> </snt-shopping-cart>
                                                </snt-nav-item>
                                            </snt-nav> : <snt-nav-item styleClasses="d-none d-md-flex">
                                            <snt-action-button id="" button-id={this.buttonIdsJson["getAQuoteId"]} button-class="get-a-quote-header" styleClasses="cta theme-default" actionReference="Action.openGetQuoteModal" actionData={this.gaqButtonActionData}
                                            linkTitle={this.languageStrings["gaq"] || "Get a Quote"}> </snt-action-button>
                                            </snt-nav-item>
                                        }
                                    </div>
                                    <div id="switch-container-tablet">
                                        <snt-nav id="actions-nav" class="actions-nav theme-header-nav" expander="false" role="list">
                                            <div id="tablet-top-quote-wrapper" class="show" role="listitem">
                                                <snt-nav-item styleClasses="d-md-flex">
                                                    <snt-action-button
                                                        id=""
                                                        button-id={this.buttonIdsJson["getAQuoteId"]} 
                                                        button-class="get-a-quote-header"
                                                        styleClasses={`cta theme-default ${!this.showShoppingCart() ? "" : "hide"}`}
                                                        actionReference="Action.openGetQuoteModal"
                                                        actionData={this.gaqButtonActionData}
                                                        linkTitle={this.languageStrings["gaq"] || "Get a Quote"}
                                                        swappableText={this.languageStrings["gaqSmall"]}>
                                                    </snt-action-button>
                                                </snt-nav-item>
                                            </div>
                                            {
                                                this.showShoppingCart() &&
                                                <snt-shopping-cart cartValue={this.cartValue} role="listitem"></snt-shopping-cart>
                                            }
                                            <div role="listitem" style={{ margin: '0'}}>
                                                <button class="hamburger hamburger--squeeze js-hamburger hamburger-squeeze-custom" aria-label="Main navigation menu" role="button" type="button" onClick={() => this.toggleTabletTab()}>
                                                    <span class="hamburger-box">
                                                        <span class="hamburger-inner"></span>
                                                    </span>
                                                </button>
                                            </div>

                                        </snt-nav>
                                    </div>
                                </div>
                                <div id="tablet-items-container">
                                    {
                                        tabletItems.map(t => t)
                                    }
                                    <div class="tablet-switch-container">
                                        <snt-nav id="actions-nav" class="actions-nav theme-header-nav" expander="false">
                                            <snt-nav-item id="search-nav-item">
                                                <snt-action-button action-reference="Action.toggleTabletSearch" icon-class-name="iconNavSearch" link-title="" button-aria-label="Search"
                                                ></snt-action-button>
                                            </snt-nav-item>
                                            <snt-nav-item title="Fr" class="nav-item-right-group">
                                                <snt-link href={this.languageUrl} link-id={this.buttonIdsJson["languageToggleId"]} >{this.languageToggleText}</snt-link>
                                            </snt-nav-item>
                                            <snt-nav-item title="Log In" class="nav-item-right-group">
                                                <snt-login id="login-slot" language-json={this.languageJson} button-id={this.buttonIdsJson["logInId"]}></snt-login>
                                            </snt-nav-item>
                                        </snt-nav> 
                                    </div>
                                    <div id="tablet-quote-container">
                                        <snt-nav-item>
                                            <snt-action-button button-class="get-a-quote-m-header" button-id={this.buttonIdsJson["getAQuoteId"]} actionReference="Action.openGetQuoteModal"  linkTitle={this.languageStrings["gaq"] || "Get a Quote"} actionData={this.gaqButtonActionData} styleClasses="gaq-mobile cta theme-default d-flex d-lg-none"/>
                                        </snt-nav-item>  
                                    </div>
                                </div>
                            </snt-navbar>
                            <div id="tablet-search-container">
                                <snt-search-bar languageJson={this.languageJson} id="tablet-search-bar" buttonActionRef="Action.toggleTabletSearch" useBackdrop={false}></snt-search-bar>
                            </div>
                        </header>
                        <snt-search-bar languageJson={this.languageJson} id="desktop-search-bar" />
                    </div>
                </div>
            </Host>
        )
    }
}